import { useForm } from '../FormContext';
import { SubmitButton, type SubmitButtonProps } from '~/shared/components/buttons/SubmitButton';

export interface FormSubmitButtonProps extends Omit<SubmitButtonProps, 'onSubmit'> {
	onSubmit?: () => void;
	requireDirtyToSubmit?: boolean;
}

export function FormSubmitButton({ onSubmit, requireDirtyToSubmit = true, ...props }: FormSubmitButtonProps) {
	const { formHelpers } = useForm();
	return (
		<SubmitButton
			onSubmit={onSubmit ? onSubmit : formHelpers.submitForm}
			{...props}
			isDisabled={props.isDisabled || (requireDirtyToSubmit && !formHelpers.dirty)}
			isPending={formHelpers.isSubmitting}
		/>
	);
}
